<template>
  <div>
    <v-container class="tab-header the-main-concept pb-25">
      <div class="d-flex justify-space-between align-center flex-col-xs">
        <div>
          <h2 v-if="accountInfo && accountInfo.user">{{$t('accounts.user_profile')}}</h2>
        </div>
      </div>
    </v-container>
    <v-container class="persons-account the-main-concept p-0">
      <div class="persons-content p-0">
        <v-layout class="top-offset p-0" row v-if="accountInfo && accountInfo.user" wrap>
          <div class="d-flex w-100 flex-col-xs">
            <div>
              <v-flex class="person-info-sect1" sm12 xs12>
                <div class="avatarImg">
                  <img :alt="$t('avatar')" :src="avatar"/>
                </div>
              </v-flex>
            </div>
            <div class="d-flex flex-row w-100 justify-space-between flex-column-xs">
              <v-flex class="person-info-sect2" md6 sm6 xs12>
                <h2>{{accountInfo.user.firstName}}</h2>
                <div class="friends-contact">
                  <p v-if="accountInfo.user.companyDetails">
                    {{$t('accounts.website')}}:
                    <span><a :href="accountInfo.user.companyDetails" target="_blank">{{accountInfo.user.companyDetails}}</a></span>
                  </p>
                  <p v-if="accountInfo.user.email">{{$t('email')}}: <span>{{accountInfo.user.email}}</span></p>
                  <p v-if="accountInfo.user.phoneNumber">{{$t('phone_number')}}: <span>{{accountInfo.user.phoneNumber}}</span></p>
                </div>
                <p class="about" v-if="accountInfo.user.about">{{accountInfo.user.about}}</p>
              </v-flex>
            </div>
          </div>
        </v-layout>
      </div>
    </v-container>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {changeImageSize} from '../../helpers/main'
import NoImage from '../../assets/images/NoImage.png'

export default {
  created () {
    this.getAccountInfo()
  },
  props: ['roles'],
  name: 'CompanyPage',
  data: () => ({
    apiUrl: process.env.ROOT_API,
    avatar: ''
  }),
  computed: {
    ...mapState({
      loggedUser: state => state.auth.userData,
      accountInfo: state => state.accounts.accountInfo
    })
  },
  methods: {
    getAccountInfo () {
      this.$store.dispatch('accounts/companyInfo', {userId: this.$route.params.userId})
        .then((res) => {
          if (!this.accountInfo.user) {
            this.$router.push('/')
            return false
          }
          if (this.accountInfo.user.image) {
            this.avatar = this.apiUrl + changeImageSize(this.accountInfo.user.image, 'md')
          } else {
            this.avatar = changeImageSize(NoImage, 'md')
          }
        })
        .catch(err => {
          console.error(err)
        })
    }
  }
}
</script>

<style lang="scss">
  @import "../../assets/sass/desktop/accountsPage.scss";
  @import "../../assets/sass/desktop/notificationPage.scss";
</style>



// WEBPACK FOOTER //
// src/components/AccountsPage/CompanyPage.vue